module.exports = __webpack_public_path__ + "img/announce_character.8c3511c5.png";